"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var ControlBarButton_1 = __importDefault(require("./ControlBarButton"));
var CssScroller_1 = require("../../CssScroller");
var transifex_1 = require("../../../transifex");
var DropdownOverlayClassname = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (react_1.default.createElement(antd_1.Dropdown, __assign({}, props, { overlayClassName: className })));
};
var ScrollDropdown = styled_components_1.default(DropdownOverlayClassname)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-dropdown-menu {\n    max-height: 300px;\n    overflow-y: scroll;\n    ", "\n  }\n"], ["\n  .ant-dropdown-menu {\n    max-height: 300px;\n    overflow-y: scroll;\n    ", "\n  }\n"])), CssScroller_1.CssScroller);
var Variables = function (_a) {
    var variables = _a.variables, onVariableClick = _a.onVariableClick;
    return (react_1.default.createElement(ScrollDropdown, { placement: "bottomRight", overlay: react_1.default.createElement(antd_1.Menu, { onClick: onVariableClick, items: variables }), trigger: ["click"] },
        react_1.default.createElement(ControlBarButton_1.default, { tooltip: transifex_1.TX_INSERT_VARIABLES, icon: react_1.default.createElement(icons_1.CodeOutlined, null) })));
};
exports.default = Variables;
var templateObject_1;
